import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";

// Before pickup the delivery hours are printed on the bill of lading, so the
// driver only sees the new hours if the customer reprints the pickup package.
// The carrier isn't always emailed either (the backend skips it for future
// pickups), so the message must only claim an email when one went out.
// Shipments go on hold before pickup (payment, rebooking, a missed pickup), so
// an on-hold shipment still needs the reprint.
export function changeDeliveryHoursConfirmationMessage(
  shipmentState: ShipmentState,
  carrierEmailed: boolean,
): string {
  const notPickedUp =
    shipmentState === ShipmentState.BookingConfirmed ||
    shipmentState === ShipmentState.OnHold;

  if (notPickedUp && carrierEmailed) {
    return "The delivery hours have now been updated, and the change has been communicated to the carrier. Please also reprint your pickup package so the driver gets the updated bill of lading.";
  }
  if (notPickedUp) {
    return "The delivery hours have now been updated on your bill of lading. Please reprint your pickup package and give the driver the updated bill of lading.";
  }
  if (carrierEmailed) {
    return "The delivery hours have now been updated, and the change has been communicated to the carrier.";
  }
  return "The delivery hours have now been updated.";
}
